import { deleteLinkByHref, formatTextLinkTags } from "helpers";
import { ContainerText, QuickTips } from "./style";

function extractFirstLIAndUpdateHTML(htmlString) {
  const liRegex = /<li\b[^>]*>(.*?)<\/li>/i;
  const match = htmlString.match(liRegex);

  if (match) {
    const firstLiContent = match[1].trim();
    const updatedHTML = htmlString.replace(match[0], '');

    return {
      firstLi: firstLiContent,
      updatedHTML: updatedHTML.trim()
    };
  }

  return { firstLI: null, updatedHTML: htmlString.trim() };
}
const TextBody = ({ content, noteType, elementBodyId }) => {
  let textForRender = deleteLinkByHref(content.value, 'undefined');
  textForRender = deleteLinkByHref(textForRender, 'unsafe:[object Object]');
  textForRender = formatTextLinkTags(textForRender);
  if (textForRender && textForRender.includes('web-clarin.lilax.io')) {
    textForRender = textForRender?.replaceAll('web-clarin.lilax.io', 'www.clarin.com');
  }

  let element = extractFirstLIAndUpdateHTML(textForRender);

  if (noteType === 'recipe' && element.firstLi != null) {
    return (
      <QuickTips>
        <h2 className="tip-title" suppressHydrationWarning
          dangerouslySetInnerHTML={{
            __html: element.firstLi
          }}
        />
        <div suppressHydrationWarning
          dangerouslySetInnerHTML={{
            __html: element.updatedHTML
          }}
        />
      </QuickTips>
    );
  }

  return (
    <ContainerText className={`container-text text-embed ${noteType === 'recipe' ? 'recipe' : ''}`} suppressHydrationWarning
      dangerouslySetInnerHTML={{
        __html: textForRender,
      }}
      id={elementBodyId}
    />
  );
};
export default TextBody;
